import { useIsMutating } from '@tanstack/react-query'

/**
 * True while any IFC model-metadata update (postFileMetadata via `useUpdateIfcModelMetadata`) is in
 * flight. Matches the mutation by its `updateIfcModelMetadata` key prefix, so it reports updates
 * started anywhere. Used to disable metadata-editing controls so a second edit can't race the save.
 */
const useIsUpdatingIfcModelMetadata = (): boolean => useIsMutating(['updateIfcModelMetadata']) > 0

export default useIsUpdatingIfcModelMetadata
